<template>
  <v-menu v-model="menu" offset-y :max-height="300" :nudge-width="100" :nudge-bottom="22" :close-on-content-click="false" transition="slide-y-transition">
    <template v-slot:activator="{menu, attrs}">
      <v-text-field class="v-input--search" v-model="search" background-color="white" v-bind="attrs" v-on="menu" outlined required single-line dense placeholder="Buscar..." autocomplete="off" hide-details>
        <template v-slot:prepend-inner>
          <v-row class="text-center ml-2 mr-1" justify="center" align="center">
            <v-progress-circular v-if="loader" indeterminate color="secondary" size="20" width="2"></v-progress-circular>
            <v-icon v-else class="icon-autocomplete" color="secondary" size="20">mdi-magnify</v-icon>
          </v-row>
        </template>
      </v-text-field>
    </template>
    <template v-if="search.length >= 3">
      <v-col class="pa-0">
        <v-list class="v-list-search">
          <v-list-item class="my-0 mx-2 pa-1">
            <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Resultados para {{search}}</v-list-item-title>
          </v-list-item>
          <template v-if="!$store.state.accounts.retrieveLoader && searchList.length">
            <template v-for="item in searchList">

              <!-- subscription -->
              <v-list-item v-if="item._index === 'subscription'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('SubscriptionRetrieve', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-autorenew</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium">{{item._source.customer}}</span>
                </v-list-item-title>
              </v-list-item>
              <!-- end subscription -->

              <!-- products -->
              <v-list-item v-if="item._index === 'product'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('ProductRetrieveUpdate', item._id)">
                <v-list-item-title>
                  <span v-if="item._source.name">
                    <v-icon color="secondary" left small>mdi-puzzle</v-icon>
                    <span class="subtitle-2 text--secondary font-weight-medium">{{item._source.name}}</span>
                  </span>
                </v-list-item-title>
              </v-list-item>
              <!-- end products -->

              <!-- plan -->
              <v-list-item v-if="item._index === 'plan'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('PlanRetrieveUpdate', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-view-carousel</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium mr-1">{{item._source.amount | currency(item._source.currency)}} {{item._source.currency}}</span>
                  <span>{{item._source.product}} {{item._source.name}}</span>
                </v-list-item-title>
              </v-list-item>
              <!-- end plan -->

              <!-- addon -->
              <v-list-item v-if="item._index === 'addon'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('AddonRetrieveUpdate', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-widgets</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium mr-1">{{item._source.amount | currency(item._source.currency)}} {{item._source.currency}}</span>
                  <span>{{item._source.name}}</span>
                </v-list-item-title>
              </v-list-item>
              <!-- end addon -->

              <!-- coupon -->
              <v-list-item v-if="item._index === 'coupon'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('CouponRetrieveUpdate', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-tag</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium mr-1">{{item._source.amount | currency(item._source.currency)}} {{item._source.currency}}</span>
                  <span>{{item._source.name}}</span>
                </v-list-item-title>
              </v-list-item>
              <!-- end coupon -->

              <!-- customer -->
              <v-list-item v-if="item._index === 'customer'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('CustomerRetrieveUpdate', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-account-box</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium" v-if="item._source.name">{{item._source.name}}</span>
                </v-list-item-title>
              </v-list-item>
              <!-- end customer -->

              <!-- payment -->
              <v-list-item v-if="item._index === 'payment'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('PaymentRetrieve', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-credit-card</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium mr-1">{{item._source.amount | currency(item._source.currency)}} {{item._source.currency}}</span>
                  <span class="mr-1" v-if="item._source.customer">{{item._source.customer}}</span>
                  <v-chip v-if="item._source.status === 'succeeded'" color="defaultGrey" x-small text-color="secondary">Pagado<v-icon class="mx-1" x-small>mdi-check</v-icon></v-chip>
                  <v-chip v-else-if="item._source.status === 'requires_payment_method'" color="defaultGrey" x-small text-color="secondary">Incompleto</v-chip>
                  <v-chip v-else-if="item._source.status === 'cancelled'" color="defaultGrey" x-small text-color="secondary">Cancelado<v-icon class="mx-1" x-small>mdi-close</v-icon></v-chip>
                  <v-chip v-else-if="item._source.status === 'processing'" color="defaultGrey" x-small text-color="secondary">Procesando</v-chip>
                </v-list-item-title>
                <v-list-item-subtitle class="text-right" v-if="item._source.date">{{item._source.date | date}}</v-list-item-subtitle>
              </v-list-item>
              <!-- end payment -->

              <!-- invoice -->
              <v-list-item v-if="item._index === 'invoice'" :key="item.id" class="my-0 mx-2 pa-1" @click="goTo('InvoiceRetrieve', item._id)">
                <v-list-item-title>
                  <v-icon color="secondary" left small>mdi-receipt</v-icon>
                  <span class="subtitle-2 text--secondary font-weight-medium mr-1">{{item._source.total | currency(item._source.currency)}} {{item._source.currency}}</span>
                  <span class="mr-1">{{item._source.document}}</span>
                  <v-chip v-if="item._source.status === 'finalized' && item._source.due_date > today" color="defaultGrey" text-color="secondary" x-small>Pendiente de pago</v-chip>
                  <v-chip v-else-if="item._source.status === 'finalized' && item._source.due_date <= today" color="defaultGrey" text-color="secondary" x-small>Vencido</v-chip>
                  <v-chip v-else-if="item._source.status === 'paid'" color="defaultGrey" text-color="secondary" x-small>Pagado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                  <v-chip v-else-if="item._source.status === 'cancelled'" color="defaultGrey" text-color="secondary" x-small>Tiene nota de crédito<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
                </v-list-item-title>
                <v-list-item-subtitle class="text-right" v-if="item._source.date">{{item._source.date | date}}</v-list-item-subtitle>
              </v-list-item>
              <!-- end invoice -->

            </template>
          </template>
        </v-list>
      </v-col>
      <v-col v-if="!$store.state.accounts.retrieveLoader && !searchList.length" class="text-center py-12">
        <v-icon class="mb-5" color="secondary" size="40">mdi-magnify</v-icon>
        <span class="d-block body-1 text--secondary font-weight-medium">No se han encontrado resultados para tu búsqueda</span>
        <span class="d-block">Inténtalo de nuevo con una búsqueda diferente</span>
      </v-col>
    </template>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex'
import ListViewMixin from "@/mixins/ListViewMixin"
import debounce from 'lodash/debounce'
export default {
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    search: '',
    loader: false,
    menu: false
  }),
  computed: mapState({
    searchList: state => state.accounts.searchList,
    searchCount: state => state.accounts.searchCount
  }),
  watch: {
    search: debounce(function () {
      if (this.search.length < 3) {
        return false
      }
      this.menu = true
      this.getSearch()
    }, 600),
    $route () {
      this.search = ''
    }
  },
  methods: {
    getSearch () {
      const query = {
        query: this.search
      }
      this.loader = true
      this.$store.dispatch('accounts/SEARCH_LIST', {
        resource: 'search',
        query: query
      })
      .finally(() => {
        this.loader = false
      })
    },
    goTo (name, id) {
      this.$router.push({ name: name, params: { id: id }}).catch(err => err)
      this.menu = false
    }
  }
}
</script>
<style>
.v-input.v-input--search > .v-input__control > .v-input__slot {
  min-height: 36px !important;
}
</style>